export function sortByProperty<T>(
  array: T[],
  propName: keyof T,
  options?: { nullsFirst?: boolean }
): T[] {
  const { nullsFirst = false } = options || {};

  return [...array].sort((a, b) => {
    const aValue = a[propName];
    const bValue = b[propName];

    const aIsNull = aValue === null || aValue === undefined;
    const bIsNull = bValue === null || bValue === undefined;

    if (aIsNull && bIsNull) return 0;
    if (aIsNull) return nullsFirst ? -1 : 1;
    if (bIsNull) return nullsFirst ? 1 : -1;

    if (aValue! < bValue!) return -1;
    if (aValue! > bValue!) return 1;
    return 0;
  });
}


export function maxByProperty<T>(array: T[], propName: keyof T): T | undefined {
  return array.reduce<T | undefined>((prev, cur) => {
    const prevValue = prev?.[propName];
    const curValue = cur[propName];

    if (curValue === null || curValue === undefined) return prev;
    if (prevValue === null || prevValue === undefined) return cur;

    return prevValue > curValue ? prev : cur;
  }, undefined);
}
